import React from 'react';
export function PainPoints() {
  const pains = [{
    emoji: '😤',
    short: 'Perseguís clientes por WhatsApp todos los meses'
  }, {
    emoji: '😩',
    short: 'Llegás al cierre con info incompleta'
  }, {
    emoji: '😬',
    short: 'Siempre alguien "se olvidó" o manda tarde'
  }, {
    emoji: '😤',
    short: 'Perdés horas en idas y vueltas evitables'
  }, {
    emoji: '😰',
    short: 'Tus clientes no respetan los tiempos'
  }, {
    emoji: '😓',
    short: 'Cada mes improvisás cómo pedir la info'
  }];
  return <section className="py-12 bg-white" data-id="element-92">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-93">
        <h2 className="text-2xl md:text-3xl font-black text-center text-gray-900 mb-8" data-id="element-94">
          ¿Sos contador y te pasa esto?
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3" data-id="element-95">
          {pains.map((pain, index) => <div key={index} className="flex items-center gap-3 p-3.5 bg-red-50 rounded-xl border border-red-100" data-id="element-96">
              <span className="text-2xl flex-shrink-0" data-id="element-97">{pain.emoji}</span>
              <p className="text-sm font-semibold text-gray-800 leading-snug" data-id="element-98">
                {pain.short}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}